import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import TaxPayerApiKey from "../../models/taxpayer-api-key";

interface TaxPayerApiKeyCrudActionsProps {
  apiKey: TaxPayerApiKey;
  onEditClick: (_: TaxPayerApiKey) => void;
  onRevokeClick: (_: TaxPayerApiKey) => void;
}

const TaxPayerApiKeyCrudActions: React.FC<TaxPayerApiKeyCrudActionsProps> = ({
  apiKey,
  onEditClick,
  onRevokeClick,
}) => {
  return (
    <td className="text-center">
      <CButtonGroup>
        <CTooltip content={"Editar"}>
          <CButton
            color="warning"
            className="text-white"
            onClick={() => {
              onEditClick(apiKey);
            }}
          >
            <i className="fa fa-pencil"></i>
          </CButton>
        </CTooltip>
        <CTooltip content={"Revocar"}>
          <CButton
            className="text-white"
            color="danger"
            onClick={() => {
              onRevokeClick(apiKey);
            }}
          >
            <i className="fa fa-ban"></i>
          </CButton>
        </CTooltip>
      </CButtonGroup>
    </td>
  );
};

export default TaxPayerApiKeyCrudActions;
